import React from 'react';
import App from 'src/App';
import 'src/index.css';
import { createRoot } from 'react-dom/client';
import Providers from './Providers';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <Providers>
    <App />
  </Providers>
);
